import { Component, Input } from '@angular/core';
import { MiniGameStudent } from '../../../interfaces/mini-game.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-student-avatar',
  template: `
    <div class="avatar"
         [style.--avatar-size]="size"
         [class.active]="active"
         [class.highlight]="highlight">
      <img [src]="getImageUrl()"
           alt=""
           class="avatar-img"
           (error)="onImgError($event)"/>
    </div>
  `,
  styles: [`
    .avatar {
      width: calc(var(--avatar-size) * 1px * var(--game-scale, 1));
      height: calc(var(--avatar-size) * 1px * var(--game-scale, 1));
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      border: 2px solid rgba(255,255,255,0.2);
      flex-shrink: 0;
      overflow: hidden;
    }
    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `]
})
export class StudentAvatarComponent {
  @Input() student: MiniGameStudent | null = null;
  @Input() size = 40;
  @Input() active = false;
  @Input() highlight = false;

  getImageUrl(): string {
    if (this.student?.image_path) {
      const filename = this.student.image_path.split('/').pop() || '';
      if (filename !== 'avatar.png') {
        return environment.img_url + this.student.image_path;
      }
    }
    return 'assets/images/avatar.png';
  }

  onImgError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/avatar.png';
  }
}
